import { render, staticRenderFns } from "./SendFeeTip.vue?vue&type=template&id=1aef6975&scoped=true"
import script from "./SendFeeTip.vue?vue&type=script&lang=js"
export * from "./SendFeeTip.vue?vue&type=script&lang=js"
import style0 from "./SendFeeTip.vue?vue&type=style&index=0&id=1aef6975&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aef6975",
  null
  
)

export default component.exports